import { useQuery } from "@tanstack/react-query";
import { verifyEmail } from "@/adapters/api";

export function useConfirmEmailVerification(token: string | null) {
	return useQuery({
		queryKey: ["confirm-email-verification", token],
		queryFn: () => verifyEmail(token as string),
		enabled: token !== null,
		retry: false,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});
}
